import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController } from '@ionic/angular';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-clist',
  templateUrl: './clist.page.html',
  styleUrls: ['./clist.page.scss'],
})

export class ClistPage implements OnInit {

  data:any;
  view:any;
  constructor(private socialSharing: SocialSharing,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

    if(!localStorage.getItem(Constant.userId) || localStorage.getItem(Constant.userId) == undefined || localStorage.getItem(Constant.userId) == 'null')
    {
      this.nav.navigateRoot('/home');
    }

  }

  ngOnInit()
  {
    this.loadData();
  }

  detail(id)
  {
    this.view = this.view == id ? 0 : id;
  }

  async loadData()
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.clientList().subscribe((response:any) => {

    this.data = response.data;

    loading.dismiss();

    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }
}
